/**
 * @generated SignedSource<<6837b1662181fa3feff08f9973248f40>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type UserProfileClientForConfluenceQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    permissionType: SitePermissionType | null;
  };
export type UserProfileClientForConfluenceQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: UserProfileClientForConfluenceQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type UserProfileClientForConfluenceQuery_entitlements_Entitlements_externalCollaborator_ExternalCollaboratorFeature =
  {
    __typename?: "ExternalCollaboratorFeature";
    isEntitled: boolean;
  };
export type UserProfileClientForConfluenceQuery_entitlements_Entitlements = {
  __typename?: "Entitlements";
  externalCollaborator: UserProfileClientForConfluenceQuery_entitlements_Entitlements_externalCollaborator_ExternalCollaboratorFeature;
};
export type UserProfileClientForConfluenceQuery_Query = {
  __typename?: "Query";
  user: UserProfileClientForConfluenceQuery_user_AtlassianUser | null;
  entitlements: UserProfileClientForConfluenceQuery_entitlements_Entitlements;
};
export type UserProfileClientForConfluenceQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["ID"]["input"]>;
}>;
export type UserProfileClientForConfluenceQuery =
  UserProfileClientForConfluenceQuery_Query;
